import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/certificates/digital-ocean-partner.svg")